import { render, staticRenderFns } from "./LaporanPelunasan.vue?vue&type=template&id=ccb6c9bc&"
import script from "./LaporanPelunasan.vue?vue&type=script&lang=js&"
export * from "./LaporanPelunasan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports